import React from 'react';
import { Breadcrumb, Button, Col, message, PageHeader, Row, Space, Modal, Table } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
      CheckCircleOutlined,
      PlusSquareOutlined,
      TableOutlined,
      ExclamationCircleOutlined,
      CalculatorOutlined,
} from '@ant-design/icons';

import {
      get4DCollections,
      calculate4d,
      toggleAdd4DCollectionModal
} from '../../redux/actions/4DCollection';

const { confirm, success } = Modal;

class FourDCollection extends React.Component {
      componentDidMount() {
            this.props.onGetAll(this.props.token);
      }

      componentDidUpdate() {
            if (this.props.error) {
                  message.error(this.props.error);
            }
      }

      _showNumbers = (id) => {
            this.props.history.push("/fourDCollections/" + id);
      }

      calculate = (id) => {
            confirm({
                  title: 'Confirm',
                  icon: <ExclamationCircleOutlined />,
                  content: 'Are you sure to calculate?',
                  okText: 'Yes',
                  cancelText: 'Cancel',
                  onOk: async () => {
                        await this.props.onCalculate(id, this.props.token);
                        if (this.props.response) {
                              success({
                                    content: `Calculated ${this.props.response.calculatedBetCount} bets`,
                              })
                        }
                  }
            })
      }

      render() {
            const columns = [
                  {
                        title: 'ID',
                        dataIndex: 'id',
                        key: 'id',
                  },
                  {
                        title: 'Collection ID',
                        dataIndex: 'collectionId',
                        key: 'collectionId',
                  },
                  {
                        title: 'Numbers',
                        align: 'center',
                        render: (text, record) => (
                              <Space size="middle" direction="horizontal" style={{ color: '#23ACFD' }}>
                                    <TableOutlined onClick={() => this._showNumbers(record.id)} />
                                    <CheckCircleOutlined onClick={() => {
                                          this.props.history.push("/fourDResults/" + record?.fourDResultId);
                                    }} />
                                    <CalculatorOutlined onClick={() => this.calculate(record.id)} />
                              </Space>
                        )
                  }
            ]
            return (
                  <Row>
                        <Col span={24}>
                              <Breadcrumb style={{ margin: '16px 0' }}>
                                    <Breadcrumb.Item>Four D Collections</Breadcrumb.Item>
                              </Breadcrumb>
                              <PageHeader
                                    style={{
                                          display: 'flex',
                                          flexDirection: 'row',
                                          justifyContent: 'space-between',
                                          border: '1px solid rgb(235, 237, 240)',
                                    }}
                                    title="Four D Collection"
                              >
                                    <Button
                                          icon={<PlusSquareOutlined />}
                                          style={{ background: '#3071b9', color: 'white' }}
                                          onClick={() => this.props.onOpenAdd()}
                                    />
                              </PageHeader>
                              <Row>
                                    <Col span={24} style={{ overflowX: 'auto' }}>
                                          <Table dataSource={this.props.collections} columns={columns} loading={this.props.loading} />
                                    </Col>
                              </Row>
                        </Col>
                  </Row>
            );
      }
}

const mapStateToProps = state => ({
      token: state.auth.token,
      collections: state.fourDCollection.all,
      error: state.fourDCollection.error,
      loading: state.fourDCollection.loading,
      response: state.fourDCollection.calculateResponse,
})

const mapDispatchToProps = dispatch => ({
      onGetAll: (token) => dispatch(get4DCollections(token)),
      onOpenAdd: () => dispatch(toggleAdd4DCollectionModal()),
      onOpenFinish: (id) => console.log(id),
      onCalculate: (id, token) => dispatch(calculate4d(id, token)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FourDCollection));